const currencyFormatter = new Intl.NumberFormat('th', {
  style: 'decimal',
  currency: 'THB',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export default currencyFormatter;
